import { Guid } from '@fitscovery/common/types';

export interface Post {
  id: Guid | string;
  userId: Guid | string;
  mediaUrl: string;
  title: string;
  description: string;
  postCategoryId: number | string;
  privacy: Privacy;
  postCategory: PostCategory;
  createdAt: Date;
  displayName: string;
}

export interface PostCategory {
  id: number;
  title: string;
  description: string;
}

export enum Privacy {
  Private,
  Public
}
